import React from "react";
import {
  RadioGroup as MuiRadioGroup,
  FormControl,
  Stack,
  Typography,
} from "@mui/material";
import { RadioButton } from "./RadioButton";
import { SvgIconComponent } from "@mui/icons-material";
import { IconWithTooltip } from "common/tooltip";

export interface RadioOption {
  value: string;
  label: string;
  helperText?: string;
  tooltipTitle?: string;
  disabled?: boolean;
  startIcon?: SvgIconComponent;
  "data-custom-css-value"?: string; // for form custom css
}

export interface IRadioGroupProps {
  value: string;
  onChange: (value: string) => void;
  options: RadioOption[];
  label?: string;
  helperText?: string;
  row?: boolean;
  tooltipTitle?: string;
}
export const RadioGroup: React.FC<IRadioGroupProps> = ({
  label,
  tooltipTitle,
  options,
  row = false,
  helperText,
  value,
  onChange,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };
  return (
    <FormControl sx={{ display: "flex", flexDirection: "column" }}>
      {label && (
        <Stack direction="row" alignItems="center" gap={0.5}>
          <Typography variant="subtitle2">{label}</Typography>
          {tooltipTitle && (
            <IconWithTooltip tooltipText={tooltipTitle} variant="help" />
          )}
        </Stack>
      )}
      <MuiRadioGroup value={value} onChange={handleChange} row={row}>
        {options.map((option) => (
          <RadioButton
            key={option.value}
            label={option.label}
            disabled={option.disabled}
            helperText={option.helperText}
            tooltipTitle={option.tooltipTitle}
            value={option.value}
            startIcon={option.startIcon}
            data-custom-css-value={option["data-custom-css-value"]}
          />
        ))}
      </MuiRadioGroup>
      {helperText && (
        <Typography variant="caption" color="text.secondary">
          {helperText}
        </Typography>
      )}
    </FormControl>
  );
};
